export default "__VITE_ASSET__BjJ_JNKO__"